<div id="supplyDetailsMap" class="w-100" style="height: 100vh;">
    <div class="position-absolute" id="map_tooltips" data-bs-html="true">
    </div>
</div>